import type PaymentErrorData from '@@/package/apis/subscription/response/PaymentErrorData';
import type CustomResponse from '~~/package/types/ResponseType';
import { AxiosError } from 'axios';

export function usePaymentError() {
    function getErrorData(error: unknown): PaymentErrorData | undefined {
        if (error instanceof AxiosError) {
            const data = error.response?.data as CustomResponse<PaymentErrorData> | undefined;
            return data?.data;
        }
        return undefined;
    }

    function getErrorCode(error: unknown): string | undefined {
        return getErrorData(error)?.errorCode;
    }

    return { getErrorCode, getErrorData };
}
